import { types } from '../../../constants/ActionTypes'

const initialState = {
  settings: undefined,
}

const settings = (state = initialState, action) => {
  switch (action.type) {
    case types.auth0.CHANGED_AUTH_STATE:
      if (action.user === null) {
        return { ...state, settings: undefined }
      }
      return state
    case types.fetch.user.RESPONSE_SETTINGS:
      if (action.response.result !== true) {
        return state
      }
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.response.settings,
        }
      }
    case types.fetch.user.RESPONSE_UPDATE:
      if (action.response.result !== true) {
        return state
      }
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.response.settings,
        }
      }
    case types.accountSettingsCard.RESPONSE_UPDATE:
      if (action.response.result !== true) {
        return state
      }
      return {
        ...state,
        settings: {
          ...state.settings,
          ...action.response.settings,
        }
      }
    case types.accountSettingsCard.RESPONSE_UPLOAD_AVATAR:
      if (action.response.result !== true) {
        return state
      }
      return {
        ...state,
        settings: {
          ...state.settings,
          avatarPhotoURL: action.response.photoURL,
        }
      }
    case types.accountSettingsCard.RESPONSE_UPLOAD_HEADER:
      if (action.response.result !== true) {
        return state
      }
      return {
        ...state,
        settings: {
          ...state.settings,
          headerPhotoURL: action.response.photoURL,
        }
      }
    default:
      return state
  }
}

export default settings



// WEBPACK FOOTER //
// ./src/reducers/Page/Settings/Settings.js